var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRed1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11111 0H56.8889C58.7749 0 60.5836 0.749204 61.9172 2.0828C63.2508 3.41639 64 5.22513 64 7.11111V56.8889C64 58.7749 63.2508 60.5836 61.9172 61.9172C60.5836 63.2508 58.7749 64 56.8889 64H7.11111C5.22513 64 3.41639 63.2508 2.0828 61.9172C0.749204 60.5836 0 58.7749 0 56.8889V7.11111C0 5.22513 0.749204 3.41639 2.0828 2.0828C3.41639 0.749204 5.22513 0 7.11111 0ZM32 24.8889C30.114 24.8889 28.3053 25.6381 26.9717 26.9717C25.6381 28.3053 24.8889 30.114 24.8889 32C24.8889 33.886 25.6381 35.6947 26.9717 37.0283C28.3053 38.3619 30.114 39.1111 32 39.1111C33.886 39.1111 35.6947 38.3619 37.0283 37.0283C38.3619 35.6947 39.1111 33.886 39.1111 32C39.1111 30.114 38.3619 28.3053 37.0283 26.9717C35.6947 25.6381 33.886 24.8889 32 24.8889Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed1);
export default __webpack_public_path__ + "static/media/red1.76e19711b5836b78c22a1aa35c3ea6b5.svg";
export { ForwardRef as ReactComponent };